import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import AIPromptsManagement from '../../components/admin/AIPromptsManagement';

const AIPromptsPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="p-6">
        <AIPromptsManagement />
      </div>
    </AdminLayout>
  );
};

export default AIPromptsPage;